import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getAssets = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/assets${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getAssetNotes = (id, query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/assetNotes/${id}${qs}`, {
    headers: {
      authorization: token,
    },
  });
};

export const createNote = (data, token) =>
  axios.post(`${baseUrl}/assetnote`, data, {
    headers: {
      authorization: token,
    },
  });

export const getAssetAudits = (query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/assetAudits${qs}`, {
    headers: {
      authorization: token,
    },
  });
};

export const createAsset = (data, token) =>
  axios.post(`${baseUrl}/asset`, data, {
    headers: {
      authorization: token,
    },
  });

export const deleteAsset = (id, token) =>
  axios.delete(`${baseUrl}/asset/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updateAsset = (id, data, token) =>
  axios.patch(`${baseUrl}/asset/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getAssetById = (id, token) =>
  axios.get(`${baseUrl}/assetbyid/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const getCategoryById = (id, token) =>
  axios.get(`${baseUrl}/assetCategory/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const getCategoryList = (query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/categories${qs}`, {
    headers: {
      authorization: token,
    },
  });
};

export const createCategory = (data, token) =>
  axios.post(`${baseUrl}/insertCategory`, data, {
    headers: {
      authorization: token,
    },
  });

export const deleteCategory = (id, token) =>
  axios.delete(`${baseUrl}/assetCategory/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updateCategory = (id, data, token) =>
  axios.patch(`${baseUrl}/assetCategory/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

///asset assign//
export const getAssetAssignDetails = (id, query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/assetAssignDetails/${id}${qs}`, {
    headers: {
      authorization: token,
    },
  });
};

export const createAssetAssign = (data, token) =>
  axios.post(`${baseUrl}/assetAssign`, data, {
    headers: {
      authorization: token,
    },
  });
///release asset//
export const releaseAsset = (data, token) =>
  axios.post(`${baseUrl}/assetRelease`, data, {
    headers: {
      authorization: token,
    },
  });
